import _ from 'lodash'
import axios from 'axios'

const BASE_URL = '/api/v1'

export function createClient({ tokenStore }) {
  const client = axios.create({
    baseURL: BASE_URL,
  })

  client.interceptors.request.use(function(config) {
    if (_.isNil(config.headers)) {
      config.headers = {}
    }
    let token = tokenStore.token
    if (token) {
      config.headers['x-api-auth'] = 'Bearer ' + token
    }
    return config
  })

  client.interceptors.response.use(
    function(response) {
      let token = response.headers['x-api-auth']
      if (token) {
        tokenStore.setToken({ token })
      }
      return Promise.resolve(response)
    },
    function(error) {
      let message = error.message
      let code = null
      if (!_.isNil(error.response)) {
        if (!_.isNil(error.response.data)) {
          if (!_.isEmpty(error.response.data.error)) {
            message = code = error.response.data.error
          }
          if (!_.isEmpty(error.response.data.message)) {
            if (message) {
              message = message + ': ' + error.response.data.message
            } else {
              message = error.response.data.message
            }
            if (_.isNil(code)) {
              code = message
            }
          }
          if (!_.isEmpty(error.response.data.detail)) {
            if (!message) {
              message = error.response.data.detail
            }
          }
        }
      }
      message = _.truncate(message, { length: 140, separator: /,? +/ })
      Object.assign(error, { code, message })
      return Promise.reject(error)
    }
  )
  return client
}
